import { render, staticRenderFns } from "./editMaintainanceStandard.vue?vue&type=template&id=52f878a4"
import script from "./editMaintainanceStandard.vue?vue&type=script&lang=js"
export * from "./editMaintainanceStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports